import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDiff',
  standalone: true
})
export class TimeDiffPipe implements PipeTransform {
  transform(value: string | Date, unit: 'minutes' | 'hours' = 'minutes'): number {
    const now = Date.now();

    const bookingDate = typeof value === 'string'
      ? new Date(value.endsWith('Z') ? value : value + 'Z').getTime()
      : new Date(value).getTime();

    const diffMs = Math.abs(now - bookingDate);

    return unit === 'hours'
      ? Math.floor(diffMs / (1000 * 60 * 60))
      : Math.floor(diffMs / (1000 * 60));
  }
}